import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M18 21a6 6 0 0 0-12 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "11", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "18", height: "18", x: "3", y: "3", rx: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "UserSquare2";
const UserSquare2 = memo(themed(Icon));
export {
  UserSquare2
};
//# sourceMappingURL=user-square-2.js.map
